// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r8-c";
export var backButton = "_r8-4";
export var backIcon = "_r8-5";
export var chevronShortcut = "_r8-6";
export var container = "_r8-1";
export var editor = "_r8-8";
export var editorWrapper = "_r8-7";
export var prefix = "_r8-2";
export var searchIcon = "_r8-3";
export var suffix = "_r8-9";
export var suffixContent = "_r8-a";
export var suffixText = "_r8-b";
export var wrapper = "_r8-0";